<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="impuesto" titulo="Impuesto / Catalogos" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>                                        
                    </div>
                </section>
                
                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">                    
                    <div class="columns">        
                        <div class="column is-6">
                            <label class="label">Nombre:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                                    placeholder="Nombre" formControlName="nombre">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div> 

                        <div class="column is-6">
                            <label class="label">Porcentaje:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="number" [ngClass]="{'is-danger': ctrl.dato.get('porcentaje').hasError('required') && ctrl.dato.get('porcentaje').hasError('required')}"
                                    placeholder="Porcentaje" formControlName="porcentaje">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('porcentaje').hasError('required') && ctrl.dato.get('porcentaje').hasError('required')">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('porcentaje').hasError('required') && ctrl.dato.get('porcentaje').hasError('required')">Este campo es requerido.</span>
                            </p>
                        </div> 
                    </div>
                    
                </section>
            </form>
        </div>
    </div>
</div>